<div class="review-card">
  <div class="review-card-head">
    <img [src]="review.avatar" alt="Image" class="review-profile">
    <div class="review-info-block">
      <h4 class="food-name">{{ review.name }}</h4>
      <h6 class="place-type">{{ review.date | date:'MMM d, y' }}</h6>
    </div>
    <div class="rating-block">
      <div class="ratig-inner">
        <h5 class="ratings">{{ review.rating }}</h5>
        <span class="rating-icon">
          <img [src]="review.ratingIcon" alt="Rating">
        </span>
      </div>
      <p class="rated-time">{{ review.ratedTime }}</p>
    </div>
  </div>
  <div class="review-card-body gallery-grid">
    <h4 class="review-text-data review-spacing font-bold">{{ review.quickPhrase }}</h4>
    <h4 class="review-text-data review-spacing">{{ review.description }}</h4>
    <a class="review-img-click" *ngIf="review.numPhotos > 0 && !isShowImage" (click)="isShowImage=!isShowImage">
      <img src="./assets/images/ic-photo.svg" alt="Star" class="review-img">
      {{ review.numPhotos }} photos
    </a>
    <div *ngIf="isShowImage" class="row row-gutter review-images-margin-top review-spacing">
      <ng-container *ngFor="let item of review.crmNoteImages">
        <div class="col-sm-6 col-md-4">
          <app-photos-section [imageUrl]="item.imageURL" [showButtons]="false"
                              class="col-sm-6 col-md-4"></app-photos-section>
        </div>
      </ng-container>
    </div>
    <a class="review-img-click" *ngIf="isShowImage" (click)="isShowImage=!isShowImage">
      <img src="./assets/images/ic-photo.svg" alt="Star" class="review-img">
      Hide Photos
    </a>
    <div class="review-images-margin-top" *ngIf="review.tagsList">
      <h4 class="review-text-data review-spacing font-bold">What Went Great</h4>
      <h4 class="review-text-data review-spacing review-tags-padding-left" *ngFor="let tags of review.tagsList">{{tags}}</h4>
    </div>
  </div>
  <div class="reply-block" *ngIf="review.reply">
    <div class="review-card-head">
      <img [src]="review.reply.avatar" alt="Image" class="review-profile">
      <div class="review-info-block">
        <h4 class="food-name">{{ review.reply.name }}</h4>
        <h6 class="place-type">{{ review.reply.type }}</h6>
      </div>
    </div>
    <div class="review-card-body">
      <h4 class="review-text-data">{{ review.reply.text }}</h4>
    </div>
  </div>
</div>

